import Matter from 'matter-js'

export default class MatterStraw {
  private straw: Matter.Body
  private size: Matter.Vector

  constructor(world: Matter.World, x: number, y: number, w: number = 20, h: number = 300) {
    const mainBody = Matter.Bodies.rectangle(
      x, y - h / 2, w, h, {
        restitution: 0.0001,
        frictionAir: 1,
        density: 0.0001,
        collisionFilter: {
          group: 0,
          category: -1,
          mask: 0b101
        }
      }
    )
    const ballast = Matter.Bodies.polygon(
      x, y, 3, w, {
        restitution: 0.0001,
        density: 2.0,
        angle: Math.PI / 6,
        collisionFilter: {
          group: 0,
          category: -1,
          mask: 0b101
        }
      }
    )
    this.straw = Matter.Body.create({
      parts: [
        mainBody,
        ballast
      ],
      collisionFilter: {
        group: 0,
        category: -1,
        mask: 0b101
      }
    })
    this.size = Matter.Vector.create(w, h)
    this.straw.angle = Math.PI / 100
    Matter.World.add(world, this.straw)
  }

  public get x(): number {
    return this.straw.position.x
  }
  public get y(): number {
    return this.straw.position.y
  }
  public get w(): number {
    return this.size.x
  }
  public get h(): number {
    return this.size.y
  }
  /** @return angle in radians */
  public get rotation(): number {
    return this.straw.angle
  }

}